// extracted by mini-css-extract-plugin
export var actionButton = "_eg-0";
export var fileInput = "_eg-2";
export var paperclip = "_eg-1";